"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchQueryValidationDto = exports.DeleteGripsDtoValidation = exports.EditGripsDtoValidation = void 0;
const yup = require("yup");
const app_1 = require("./app");
exports.EditGripsDtoValidation = yup.object({
    id: yup.string().required(),
    date_updated: yup.date(),
    make: yup.string().required(),
    model: yup.string().required(),
    description: yup.string().nullable(),
    mass_g: yup.number().nullable(),
    sku: yup.string().required(),
    price: yup.string().nullable(),
    deletedAt: yup.date().nullable(),
});
exports.DeleteGripsDtoValidation = yup.object({
    ids: yup.array().of(yup.string()).min(1).required(),
});
exports.SearchQueryValidationDto = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    searchFilter: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
//# sourceMappingURL=grips.js.map